/**
 * Parses a pipe-delimited response string into an object.
 *
 * Example:
 * response=transfer-request-cancelled|request=collect-on-bus|treq_id=11601
 *
 * becomes:
 * {
 *   response: "transfer-request-cancelled",
 *   request: "collect-on-bus",
 *   treq_id: "11601"
 * }
 */
export function parseResponse(responseText) {
  if (!responseText || typeof responseText !== "string") {
    return {};
  }

  return responseText.split("|").reduce((result, part) => {
    const separatorIndex = part.indexOf("=");

    if (separatorIndex === -1) {
      return result;
    }

    const key = part.slice(0, separatorIndex).trim();
    const value = part.slice(separatorIndex + 1).trim();

    if (key) {
      result[key] = value;
    }

    return result;
  }, {});
}


/**
 * Returns a specific value from the response.
 */
export function getResponseValue(responseText, key) {
  const parsed = parseResponse(responseText);
  return parsed[key] ?? "";
}


/**
 * Convenience function for request=...
 */
export function parseRequest(responseText) {
  return getResponseValue(responseText, "request");
}